import { Injectable } from '@angular/core';
import {
    HttpClient, HttpHeaders, HttpParams,
} from '@angular/common/http';
import { Configuration } from '../configuration';
import { CustomHttpUrlEncodingCodec } from '../encoder';
import { Observable } from 'rxjs';
import { EnvironmentService } from './environment.service';
import { environment } from '../../../environments/environment';
import { VersionService } from '../../services/version.service'



@Injectable()
export class ApiWebService {
    public basePath = window.location.origin.includes('localhost') ? environment.url_api : this.envService.validatorURL(window.location.origin) + '/ivcert';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected http: HttpClient, private envService: EnvironmentService, private verService: VersionService) {
        this.defaultHeaders = this.defaultHeaders.set('X-Request-ID', 'app-front');
    }

    private checkBasePath(): boolean {
        var rtn = false;

        if (this.basePath) {
            rtn = true;
        }

        return rtn;
    }

    /**
     *
     *
     * @param authorization The authorization token
     * @param $Top The max number of records. (e.g. $top&#x3D;10)
     * @param $Skip The number of records to skip. (e.g. $skip&#x3D;5)
     * @param $Filter A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq &#39;bob&#39;)
     * @param $Select Specifies a subset of properties to return. (e.g. $select&#x3D;Name)
     * @param $Inlinecount Tells the server to include the total count of matching entities in the response. (e.g. $inlinecount&#x3D;allpages)
     * @param $Orderby Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     */
    public GetWithHttpInfo(authorization: any, endpoint: any, $Top?: any, $Skip?: any, $Filter?: any, $Select?: any, $Inlinecount?: any, $Orderby?: any, extraHttpRequestParams?: any): Observable<any> {

        //Comprobamos previamente que exista la URL donde conectarnos
        if (!this.checkBasePath()) {
            throw new Error('Error en la configuración. No existe la URL de conexión a los servicios.');
        }

        //Comprobamos que exista el endpoint
        if (endpoint === null || endpoint === undefined) {
            throw new Error('Required parameter endpoint was null or undefined.');
        }

        endpoint = this.verService.getUrlEndpoint(endpoint)
        const path = this.basePath + endpoint;

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        let headers: HttpHeaders = this.defaultHeaders; // https://github.com/angular/angular/issues/6845
        // verify required parameter 'authorization' is not null or undefined
        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined.');
        }
        if ($Top !== undefined && $Top !== null) {
            queryParameters = queryParameters.set('$top', <any>$Top);
        }
        if ($Skip !== undefined && $Skip !== null) {
            queryParameters = queryParameters.set('$skip', <any>$Skip);
        }
        if ($Filter !== undefined && $Filter.length) {
            queryParameters = queryParameters.set('$filter', <any>$Filter);
        }
        if ($Select !== undefined && $Select !== null) {
            queryParameters = queryParameters.set('$select', <any>$Select);
        }
        if ($Inlinecount !== undefined && $Inlinecount !== null) {
            queryParameters = queryParameters.set('$inlinecount', <any>$Inlinecount);
        }
        if ($Orderby !== undefined && $Orderby !== null) {
            queryParameters = queryParameters.set('$orderby', <any>$Orderby);
        }

        headers = headers.set('Authorization', String(authorization));

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];


        let requestOptions = {
            headers: headers,
            params: queryParameters
        };

        // https://github.com/swagger-api/swagger-codegen/issues/4037
        if (extraHttpRequestParams) {
            //requestOptions = this.extendObj(requestOptions, extraHttpRequestParams);
            requestOptions = (<any>Object).assign(requestOptions, extraHttpRequestParams);
        }

        requestOptions.headers.set('Content-Type', 'application/json');
        requestOptions.headers.set('Accept', 'application/json');
        return this.http.get<any>(path, requestOptions);
    }

    async GetWithHttpInfoAsync(authorization: any, endpoint: any, $Top?: any, $Skip?: any, $Filter?: any, $Select?: any, $Inlinecount?: any, $Orderby?: any, extraHttpRequestParams?: any): Promise<any> {

      //Comprobamos previamente que exista la URL donde conectarnos
      if (!this.checkBasePath()) {
          throw new Error('Error en la configuración. No existe la URL de conexión a los servicios.');
      }

      //Comprobamos que exista el endpoint
      if (endpoint === null || endpoint === undefined) {
          throw new Error('Required parameter endpoint was null or undefined.');
      }

      endpoint = this.verService.getUrlEndpoint(endpoint)
      const path = this.basePath + endpoint;

      let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
      let headers: HttpHeaders = this.defaultHeaders; // https://github.com/angular/angular/issues/6845
      // verify required parameter 'authorization' is not null or undefined
      if (authorization === null || authorization === undefined) {
          throw new Error('Required parameter authorization was null or undefined.');
      }
      if ($Top !== undefined && $Top !== null) {
          queryParameters = queryParameters.set('$top', <any>$Top);
      }
      if ($Skip !== undefined && $Skip !== null) {
          queryParameters = queryParameters.set('$skip', <any>$Skip);
      }
      if ($Filter !== undefined && $Filter.length) {
          queryParameters = queryParameters.set('$filter', <any>$Filter);
      }
      if ($Select !== undefined && $Select !== null) {
          queryParameters = queryParameters.set('$select', <any>$Select);
      }
      if ($Inlinecount !== undefined && $Inlinecount !== null) {
          queryParameters = queryParameters.set('$inlinecount', <any>$Inlinecount);
      }
      if ($Orderby !== undefined && $Orderby !== null) {
          queryParameters = queryParameters.set('$orderby', <any>$Orderby);
      }

      headers = headers.set('Authorization', String(authorization));

      // to determine the Content-Type header
      let consumes: string[] = [
      ];

      // to determine the Accept header
      let produces: string[] = [
          'application/json'
      ];


      let requestOptions = {
          headers: headers,
          params: queryParameters
      };

      // https://github.com/swagger-api/swagger-codegen/issues/4037
      if (extraHttpRequestParams) {
          //requestOptions = this.extendObj(requestOptions, extraHttpRequestParams);
          requestOptions = (<any>Object).assign(requestOptions, extraHttpRequestParams);
      }

      requestOptions.headers.set('Content-Type', 'application/json');
      requestOptions.headers.set('Accept', 'application/json');

      return this.http.get<any>(path, requestOptions).toPromise();
  }
}
